export default __webpack_public_path__ + "static/media/mann.f7b8f753.png";